import DoctorItemButtons from './doctor-item-buttons';

export default DoctorItemButtons;
